import React, { FunctionComponent } from 'react'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../../../../App/Components'

import { IProps } from './IProps'
import { dataSetLabels, dayLabels, monthLabels } from './structure'
import { labelSwitch } from './utils/labelSwitch'

export const Timeline: FunctionComponent<IProps> = ({ appointmentStats }) => {
    const { t } = useTranslation()
    const translateDays: string[] = dayLabels.map((month) => t(month))
    const weekString = t('Week')
    const translateMonths: string[] = monthLabels.map((month) => t(month))
    const translateDataLabels: string[] = dataSetLabels.map((label) =>
        t(label.label)
    )

    if (appointmentStats === null) {
        return (
            <p>
                {t(
                    'We could not find appointment reports for the requested range.'
                )}
            </p>
        )
    }

    if (typeof appointmentStats !== 'undefined') {
        const sortedAppointmentStats = appointmentStats.sort(
            (a, b) => a.groupByNumber - b.groupByNumber
        )

        const options = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top' as const,
                },
                title: {
                    display: true,
                    text: 'Chart.js Bar Chart',
                },
            },
        }
        const timeLabels: string[] = labelSwitch(
            sortedAppointmentStats,
            translateDays,
            translateMonths,
            weekString
        )

        const labeledDataSet = dataSetLabels.map((setLabel, index) => ({
            label: translateDataLabels[index],
            data: sortedAppointmentStats.map((stat) => stat[setLabel.ref]),
            backgroundColor: setLabel.color,
        }))

        const data = {
            labels: timeLabels,
            datasets: labeledDataSet,
        }

        return <Bar options={options} data={data} />
    }
    return <Spinner />
}
